import { Grid2, Box, Typography } from '@mui/material';
import { Home } from '../types/homes';
import HomeCard from './HomeCard';

interface HomesGridProps {
  homes: Home[];
  filteredHomes: Home[];
  deletingHomeIds: string[];
  onDelete: (id: string) => Promise<void>;
  onEdit: (id: string) => void;
  onHomeClick: (homeId: string) => void;
  searchQuery?: string;
  containerSx?: object;
}

const HomesGrid: React.FC<HomesGridProps> = ({
  homes,
  filteredHomes,
  deletingHomeIds,
  onDelete,
  onEdit,
  onHomeClick,
  searchQuery = '',
  containerSx = {}
}) => {
  return (
    <Grid2 container spacing={1} sx={{ px: { xs: 2, sm: 4 }, ...containerSx }} data-testid="homes-list">
      {filteredHomes.map(home => (
        <Grid2 size={{xs: 12, md: 6, lg: 4 }} component='div' key={home.id}>
          <HomeCard
            home={home}
            onDelete={onDelete}
            onEdit={onEdit}
            onClick={onHomeClick}
            isDeleting={deletingHomeIds.includes(home.id)}
          />
        </Grid2>
      ))}
      {filteredHomes.length === 0 && homes.length > 0 && (
        <Grid2 size={12}>
          <Box sx={{ mt: 4, textAlign: 'center' }}>
            <Typography variant="body1" color="text.secondary">
              {searchQuery ? 'No homes matching your search' : 'No homes found'}
            </Typography>
          </Box>
        </Grid2>
      )}
    </Grid2>
  );
};

export default HomesGrid;